import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";

export const useWorkbookId = () => {
  const location = useLocation();

  const params = useMemo(() => {
    // Parse /mapping/:workbookId/:categoryId pattern
    const match = location.pathname.match(/^\/mapping\/([^\/]+)\/([^\/]+)$/);

    if (match) {
      return {
        workbookId: match[1],
        categoryId: match[2],
      };
    }

    return { workbookId: null, categoryId: null };
  }, [location.pathname]);

  return {
    data: params.workbookId || null,
    isLoading: false,
    isError: false,
  };
};

export const useCategoryId = () => {
  const { categoryId } = useParams();

  return {
    data: categoryId || null,
    isLoading: false,
    isError: false,
  };
};

export const useWorkbookIdAndCategoryId = () => {
  const { workbookId, categoryId } = useParams();

  return {
    workbookId: workbookId || null,
    categoryId: categoryId || null,
    isLoading: false,
    isError: false,
  };
};
